query getSearchObjectives($input: SearchObjectivesInput!) {
  searchObjectives: searchObjectives(input: $input) {
    hasMore
    totalCount
    associatedTeams {
      id
      kind
      name
      type
      parentIds
      hierarchyIds
      objectiveIds
      attributes {
        id
        attributeType
        subtype
        label
        value
      }
    }
    objectives {
      id
      name
      objectiveType
      objectiveTypeDisplayName
      dataSource {
        type
      }
      attributes {
        id
        attributeType
        subtype
        label
        value
      }
      parentIds
    }
  }
}

query getObjectiveTypes {
  getObjectiveTypes {
    type
    datasource
  }
}
